export default __webpack_public_path__ + "static/media/info-circle-yellow.d8b279a6.svg";